import { useState, useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import RecruiterLayout from '@/components/RecruiterLayout';
import { 
  ActivityLogPanel, 
  useActivityLogs 
} from '@/components/activity-log';
import { supabase } from '@/integrations/supabase/client';

const ActivityLogs = () => {
  const [actors, setActors] = useState<{ id: string; name: string }[]>([]);

  useEffect(() => {
    // Fetch actors for filter
    const fetchActors = async () => {
      const { data } = await supabase
        .from('app_users')
        .select('id, full_name')
        .order('full_name');
      
      if (data) {
        setActors(data.map(u => ({ id: u.id, name: u.full_name })));
      }
    };
    fetchActors();
  }, []);

  return (
    <RecruiterLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold mb-2">Activity Logs</h1>
          <p className="text-muted-foreground">
            Track all system changes and user actions across all entities
          </p>
        </div>

        <ActivityLogPanel
          title="All Activity"
          showFilters={true}
          showEntityBadge={true}
          maxHeight="calc(100vh - 280px)"
          limit={200}
        />
      </div>
    </RecruiterLayout>
  );
};

export default ActivityLogs;
